document.addEventListener('DOMContentLoaded', function () {
  const builder = document.querySelector('[data-nod-dtf].ndtf');

  if (!builder) return;


  /* =========================================================
     BUILD YOUR TRANSFER SHELL
     ========================================================= */

  let shell = document.querySelector('.blvnks-dtf-shell');

  if (!shell) {
    builder.dataset.blvnksWrapped = 'true';

    shell = document.createElement('div');
    shell.className = 'blvnks-dtf-shell';

    const shellHead = document.createElement('div');
    shellHead.className = 'blvnks-dtf-shell__head';

    const title = document.createElement('strong');
    title.className = 'blvnks-dtf-shell__title';
    title.textContent = 'BUILD YOUR TRANSFER';

    const tips = document.createElement('a');
    tips.className = 'blvnks-dtf-shell__tips';
    tips.href = '/pages/artwork-services';
    tips.textContent = 'ARTWORK TIPS →';

    shellHead.appendChild(title);
    shellHead.appendChild(tips);

    builder.parentNode.insertBefore(shell, builder);

    shell.appendChild(shellHead);
    shell.appendChild(builder);


    /* Secure file helper */

    const helper = document.createElement('div');
    helper.className = 'blvnks-dtf-helper';

    helper.innerHTML =
      '<span>✓ Your files are secure and only used to produce your order.</span>';

    shell.appendChild(helper);


    /* Trust row */

    const trust = document.createElement('div');
    trust.className = 'blvnks-dtf-trust';

    trust.innerHTML = `
      <div class="blvnks-dtf-trust__item">
        <strong>FAST PRODUCTION</strong>
        <span>Built for quick turnaround.</span>
      </div>

      <div class="blvnks-dtf-trust__item">
        <strong>NO MINIMUMS</strong>
        <span>Order one or scale up.</span>
      </div>

      <div class="blvnks-dtf-trust__item">
        <strong>PREMIUM PRINT</strong>
        <span>Vibrant, durable output.</span>
      </div>

      <div class="blvnks-dtf-trust__item">
        <strong>ARTWORK HELP</strong>
        <span>Production-ready support.</span>
      </div>
    `;

    shell.appendChild(trust);
  }


  /* =========================================================
     MOVE DESCRIPTION INTO PRODUCT DETAILS DROPDOWN
     ========================================================= */

  const description = document.querySelector('.ndtf-land-desc');

  if (
    description &&
    shell &&
    !document.querySelector('.blvnks-dtf-details')
  ) {
    const details = document.createElement('details');
    details.className = 'blvnks-dtf-details';

    const summary = document.createElement('summary');
    summary.className = 'blvnks-dtf-details__summary';

    summary.innerHTML = `
      <span>PRODUCT DETAILS</span>
      <span class="blvnks-dtf-details__icon">+</span>
    `;

    const content = document.createElement('div');
    content.className = 'blvnks-dtf-details__content';

    content.innerHTML = description.innerHTML;

    details.appendChild(summary);
    details.appendChild(content);

    shell.insertAdjacentElement('afterend', details);

    description.remove();
  }
});